export interface TypeaheadStreamingFieldUpdate {
  updates: App.TypeaheadStreamingUpdates
  timestamp: string
  input: string
  extractedDataType: App.TypeaheadStreamingFieldType
}

const ARRAY_DEFAULT_FIELDS = new Set<App.TypeaheadStreamingFieldType>([
  'results',
  'naturalLanguageSuggestions',
])

export function applyTypeaheadStreamingFieldUpdate(
  target: App.TypeaheadStreamingData,
  { updates, timestamp, input, extractedDataType }: TypeaheadStreamingFieldUpdate,
): void {
  const shouldUpdate = (existingTimestamp?: string): boolean => {
    if (!existingTimestamp) return true
    return timestamp > existingTimestamp
  }

  const fieldEntry = { timestamp, input }

  if (extractedDataType === 'chains') {
    if (!shouldUpdate(target.chains?.timestamp)) return
    target.chains = { data: updates.chains, ...fieldEntry }
    target.subChains = { data: updates.subChains, ...fieldEntry }
    return
  }

  const fieldKey = extractedDataType
  if (!shouldUpdate(target[fieldKey]?.timestamp)) return

  const data = updates[fieldKey] ?? (ARRAY_DEFAULT_FIELDS.has(fieldKey) ? [] : undefined)

  Object.assign(target, {
    [fieldKey]: { data, ...fieldEntry },
  } satisfies Partial<App.TypeaheadStreamingData>)
}
